<template>
  <div>
    <!-- begin #sidebar -->
    <div id="sidebar" class="sidebar" v-bind:class="{ 'sidebar-transparent': pageOptions.pageSidebarTransparent }">
      <!-- begin sidebar scrollbar -->
      <vue-custom-scrollbar class="height-full">
        <!-- begin sidebar user -->
        <!-- <sidebar-nav-profile></sidebar-nav-profile> -->
        <!-- end sidebar user -->

        <!-- begin sidebar nav -->
        <sidebar-nav ref="sidebarNav" v-bind:scrollTop="scrollTop" v-on:showFloatSubmenu="handleShowFloatSubmenu" v-on:hideFloatSubmenu="handleHideFloatSubmenu"></sidebar-nav>
        <!-- end sidebar nav -->
      </vue-custom-scrollbar>
      <!-- end sidebar scrollbar -->
    </div>
    <div class="sidebar-bg"></div>
    <!-- end #sidebar -->
    <div class="mobile-click" v-on:click="dismissSidebar"></div>

    <div
      class="float-sub-menu-container"
      @mouseover="clearHideFloatSubmenu"
      @mouseleave="handleHideFloatSubmenu"
      v-if="this.pageOptions.pageSidebarMinified"
      v-bind:class="{
        'd-none': !this.floatSubmenu,
      }"
      v-bind:style="{
        top: this.floatSubmenuTop,
        left: this.floatSubmenuLeft,
        bottom: this.floatSubmenuBottom,
        right: this.floatSubmenuRight,
      }"
    >
      <div
        class="float-sub-menu-arrow"
        v-bind:style="{
          top: this.floatSubmenuArrowTop,
          bottom: this.floatSubmenuArrowBottom,
        }"
      ></div>
      <div
        class="float-sub-menu-line"
        v-bind:style="{
          top: this.floatSubmenuLineTop,
          bottom: this.floatSubmenuLineBottom,
        }"
      ></div>
      <ul class="float-sub-menu">
        <template v-for="menu in this.floatSubmenuMenu">
          <sidebar-nav-list ref="sidebarNavList" v-bind:menu="menu" v-bind:key="menu.path" v-bind:status="menu.status" v-on:calcFloatSubmenu="handleCalcFloatSubmenu"></sidebar-nav-list>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import SidebarNav from "./SidebarNav.vue";
import SidebarNavProfile from "./SidebarNavProfile.vue";
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "@/Options/PageOptions.js";
import VueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "Sidebar",
  components: {
    SidebarNav,
    SidebarNavProfile,
    SidebarNavList,
    VueCustomScrollbar,
  },
  data() {
    return {
      scrollTop: "",
      pageOptions: PageOptions,
      floatSubmenu: false,
      floatSubmenuMenu: "",
      floatSubmenuTop: "",
      floatSubmenuBottom: "",
      floatSubmenuLeft: "",
      floatSubmenuRight: "",
      floatSubmenuArrowTop: "",
      floatSubmenuArrowBottom: "",
      floatSubmenuLineTop: "",
      floatSubmenuLineBottom: "",
      clearSubmenu: "",
      subMenuOffset: "",
    };
  },
  directives: {
    scroll: {
      inserted: function (el, binding) {
        let f = function (evt) {
          if (binding.value(evt, el)) {
            el.removeEventListener("scroll", f);
          }
        };
        el.addEventListener("scroll", f);

        if (typeof Storage !== "undefined") {
          if (localStorage.sidebarScroll) {
            el.scrollTop = localStorage.sidebarScroll;
          }
        }
      },
    },
  },
  methods: {
    handleCalcFloatSubmenu: function () {
      setTimeout(() => {
        var targetTop = this.subMenuOffset.top;
        var windowHeight = window.innerHeight;
        var targetHeight = document.querySelector(".float-sub-menu-container").offsetHeight;

        if (windowHeight - targetTop > targetHeight) {
          this.floatSubmenuTop = this.subMenuOffset.top + "px";
          this.floatSubmenuBottom = "auto";
          this.floatSubmenuArrowTop = "20px";
          this.floatSubmenuArrowBottom = "auto";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = "auto";
        } else {
          this.floatSubmenuTop = "auto";
          this.floatSubmenuBottom = "0";

          var arrowBottom = windowHeight - targetTop - 21;
          this.floatSubmenuArrowTop = "auto";
          this.floatSubmenuArrowBottom = arrowBottom + "px";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = arrowBottom + "px";
        }
      }, 0);
    },
    handleShowFloatSubmenu: function (data, offset) {
      this.floatSubmenuMenu = data;
      this.floatSubmenu = true;
      this.subMenuOffset = offset;

      var targetTop = offset.top;
      var windowHeight = window.innerHeight;

      setTimeout(() => {
        var targetHeight = document.querySelector(".float-sub-menu-container").offsetHeight;

        if (windowHeight - targetTop > targetHeight) {
          this.floatSubmenuTop = offset.top + "px";
          this.floatSubmenuBottom = "auto";
          this.floatSubmenuArrowTop = "20px";
          this.floatSubmenuArrowBottom = "auto";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = "auto";
        } else {
          this.floatSubmenuTop = "auto";
          this.floatSubmenuBottom = "0";

          var arrowBottom = windowHeight - targetTop - 21;
          this.floatSubmenuArrowTop = "auto";
          this.floatSubmenuArrowBottom = arrowBottom + "px";
          this.floatSubmenuLineTop = "20px";
          this.floatSubmenuLineBottom = arrowBottom + "px";
        }
      }, 0);

      this.floatSubmenuRight = "auto";
      this.floatSubmenuLeft = document.getElementById("sidebar").offsetLeft + offset.width + "px";

      clearTimeout(this.clearSubmenu);
    },
    handleHideFloatSubmenu: function () {
      this.clearSubmenu = setTimeout(() => {
        this.floatSubmenu = false;
      }, 250);
    },
    clearHideFloatSubmenu: function () {
      clearTimeout(this.clearSubmenu);
    },
    handleScroll: function (evt) {
      this.scrollTop = evt.target.scrollTop;
      if (typeof Storage !== "undefined") {
        localStorage.setItem("sidebarScroll", this.scrollTop);
      }
    },
    dismissSidebar: function () {
      this.pageOptions.pageMobileSidebarToggled = false;
      this.pageOptions.pageMobileRightSidebarToggled = false;
    },
  },
};
</script>

<style>
#sidebar {
  background: white !important;
  /* border-top: 1px solid grey !important; */
}

.sidebar .nav > li.nav-header {
  color: grey !important;
}

.sidebar li > a .caret:before {
  color: #a3a3a3 !important;
}

.sidebar .nav > li {
  padding: 4px 16px;
  margin: 8px 0;
  width: 100%;
  display: flex;
  align-items: center;
}

.sidebar .nav > li.expand {
  display: flex;
  height: auto;
}

.sidebar .nav > li.active {
  padding: 0 16px;
}

.sidebar .nav > li.has-sub {
  flex-direction: column;
}

.sidebar .nav > li:last-child {
  margin-top: 24px;
}

.sidebar .nav > li > a > div {
  padding: 0 16px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.sidebar .nav > li a.active-container {
  padding: 0;
}

.sidebar .nav > li > a {
  box-sizing: border-box;
  color: #a3a3a3 !important;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.sidebar .nav > li > a:not(.sidebar-minify-btn) {
  background-color: transparent !important;
}

.sidebar .nav > li.active > a > .active-container {
  padding: 0px 16px;
  border-radius: 5px;
  min-height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
}

.sidebar .nav > li.active > a > .active-container,
.sidebar .nav > li.active > a i {
  color: white !important;
  font-weight: bold;
  background: #f36f21 !important;
}

.sidebar .nav > li.active > a i.icon {
  width: 18px;
  height: 18px;
}

.sidebar .nav > li.active > a > .active-container i.icon {
  background-color: #fff;
}

.sidebar .has-sub ul {
  padding: 8px 0 0 12px; /* reset bawaan browser */
  padding-inline-start: 0;
}

li ul {
  padding: 0;
}

.sidebar .has-sub a > div {
  padding-left: 12px;
}

.sidebar .nav .sub-menu > li > a {
  color: #a3a3a3 !important;
}

.sidebar > section > ul > li.active > a > .active-container > .caret:before {
  color: white !important;
}

.page-sidebar-minified .sidebar .nav > li,
.page-sidebar-minified .sidebar .nav > li {
  padding: 4px 4px;
}

.sidebar .sub-menu > li {
  padding: 8px 0;
}

.sidebar .sub-menu > li div > span {
  margin-left: 8px;
}

.sidebar .sub-menu > li.active > a {
  color: #000 !important;
  font-weight: 600;
}

.sidebar .sub-menu > li:before,
.sidebar .sub-menu > li:after,
.sidebar .sub-menu > li > a:after,
.sidebar .sub-menu > li.active:after {
  background: transparent;
  border-color: transparent;
}

.sidebar-minify-btn {
  box-shadow: 3px 2px 2px grey;
}
</style>
